export class BlindWorkStats {
    constructor() {
        this.MakeVirginCount = 0;
        this.PowerOffCount = 0;
        this.EnterCalibrationCount = 0;
        this.ObstacleUpCount = 0;
        this.ObstacleDownCount = 0;
        this.GoRideUpCount = 0;
        this.GoRideDownCount = 0;
        this.ManualAutoConfigFlag = false;
        this.BadCrcFlag = false;
    }
}
export var WorkMode;
(function (WorkMode) {
    WorkMode[WorkMode["Automatic"] = 0] = "Automatic";
    WorkMode[WorkMode["Manual"] = 1] = "Manual";
})(WorkMode || (WorkMode = {}));
//# sourceMappingURL=ISsrVersionedService.js.map